import {
  Box,
  TodoPrioIcon,
  TodoStatusCircle,
  TouchableBox,
  useScaleFactor,
} from "arkh";
import React, { useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { TodoOverviewListItemMediumStatusAndPrio_Todo$key } from "./__generated__/TodoOverviewListItemMediumStatusAndPrio_Todo.graphql";
import { useTodoSetStatus } from "./useTodoSetStatus";
import PrioAnimation from "./PrioAnimation";
export const TodoOverviewListItemMediumStatusAndPrio = React.memo(
  TodoOverviewListItemMediumStatusAndPrioC
);
function TodoOverviewListItemMediumStatusAndPrioC(props: {
  todo: TodoOverviewListItemMediumStatusAndPrio_Todo$key;
  interactive?: boolean;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoOverviewListItemMediumStatusAndPrio_Todo on Todo {
        canWrite
        id
        status
        priority
        expireAt
        isResponseCompleted
        ordinal
        response {
          ... on TodoResponseNumber {
            __typename
          }
          ... on TodoResponseText {
            __typename
          }
          ... on TodoResponseImage {
            __typename
            images {
              id
              ...Image_image
            }
          }
        }
      }
    `,
    props.todo
  );
  const readOnly = !todo.canWrite;
  const setRemoteStatus = useTodoSetStatus(todo.id);

  const onSetStatus = useCallback(() => {
    if (props.interactive === false || readOnly) {
      return;
    }
    setRemoteStatus(todo.status === "DONE" ? "PENDING" : "DONE", todo.ordinal);
  }, [props.interactive, readOnly, setRemoteStatus, todo.status, todo.ordinal]);

  const sf = useScaleFactor();

  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      {todo.priority !== "DEFAULT" ? (
        <Box spaceRight="small">
          {todo.priority === "URGENT" && todo.status === "PENDING" ? (
            <PrioAnimation />
          ) : null}
          <TodoPrioIcon priority={todo.priority} />
        </Box>
      ) : null}
      <TouchableBox
        hitSlop={{
          top: 10 * sf,
          bottom: 10 * sf,
          left: 40 * sf,
          right: 40 * sf,
        }}
        onPress={onSetStatus}
        disabled={
          readOnly ||
          props.interactive === false ||
          !!todo.response ||
          !todo.isResponseCompleted
        }
      >
        <TodoStatusCircle
          status={todo.status}
          expireAtISO={todo.expireAt ?? null}
          response={todo.response}
          size="smallMedium"
        />
      </TouchableBox>
    </Box>
  );
}
